import {
  createContext,
  useState,
  useContext,
  useEffect
} from 'react';

export const store = {
  setModal: () => { },
};

const StoreContext = createContext(null);

const StoreContextProvider = ({ children }) => {
  const [modal, setModal] = useState({
    indexModal: null,
    identificadorModalConfirm: '',
    openModalPermissao: false,
    permissaoLiberadaGlobal: false,
    openModalInformacao: false,
    openModalConfirm: false,
    openConfirmEditItem: false,
    openModalNegativo: false,
    openModal: false,
    openModalItem: false,
    openModalCliente: false,
    openModalFecharMovimento: false,
    openModalMovimento: false,
    openModalTypePayment: false,
    openModalInformacaoMovimento: false,
    openModalTransf: false,
    openModalSaldos: false,
    openModalSugestaoQtd: false,
    tituloModal: '',
    tituloModalItem: '',
    tituloModalInformacao: '',
    tituloModalConfirm: '',
    tituloConfirmEditItem: '',
    iconeModalInformacao: '',
    textoModalInformacao: '',
    textoPermissao: '',
    subtituloModalConfirm: '',
    subtituloConfirmEdit: '',
    textoModalConfirm: '',
    textoConfirmEdit: '',
    mensagemErroPermissao: '',
    textoInformacaoMovimento: '',
    confirmEditItem: false,
    confirm: false,
  });

  store.setModal = setModal;

  const [movimentoSelecionado, setMovimentoSelecionado] = useState();
  const [nMovimento, setNMovimento] = useState();
  const [dadosClienteMov, setDadosClienteMov] = useState();
  const [movimento, setMovimento] = useState();
  const [atualizarMaterial, setAtualizarMaterial] = useState(false);
  const [rowRef, setRowRef] = useState([]);
  const [dispositivoMovel, setDispositivoMovel] = useState(false);
  const [alternarInfo, setAlternarInfo] = useState({
    container: false,
    icone: 'search'
  });
  const [utilizaPrecosWeb, setUtilizaPrecosWeb] = useState(false);

  useEffect(() => {
    const detectarDispositivo = () => {
      const larguraTela = window?.innerWidth;
      const userAgent = navigator.userAgent.toLowerCase();

      const isMobileUA =
        /android/i.test(userAgent) ||
        /iphone|ipad|ipod/i.test(userAgent) ||
        /tablet/i.test(userAgent) ||
        /mobile/i.test(userAgent);

      const isMobileByScreen = larguraTela <= 1024;

      const isDispositivoMovel = isMobileUA || isMobileByScreen;

      setDispositivoMovel(isDispositivoMovel);
    };

    detectarDispositivo();
  }, []);

  useEffect(() => {
    try {
      const valorPersistido = localStorage.getItem('utilizaPrecosWeb');
      if (valorPersistido !== null) {
        setUtilizaPrecosWeb(valorPersistido === 'true');
      }
    } catch (_) {
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('utilizaPrecosWeb', String(utilizaPrecosWeb));
    } catch (_) {
    }
  }, [utilizaPrecosWeb]);

  const value = {
      modal,
      setModal,
      rowRef,
      setRowRef,
      alternarInfo,
      setAlternarInfo,
      dispositivoMovel,
      setDispositivoMovel,
      movimentoSelecionado,
      setMovimentoSelecionado,
      nMovimento,
      setNMovimento,
      dadosClienteMov,
      setDadosClienteMov,
      movimento,
      setMovimento,
      atualizarMaterial,
      setAtualizarMaterial,
      utilizaPrecosWeb,
      setUtilizaPrecosWeb,
  };

  return (
    <StoreContext.Provider
      value={value}
    >
      {children}
    </StoreContext.Provider>
  );
};

const useStoreContext = () => useContext(StoreContext);

export { StoreContextProvider, useStoreContext };
